import { ReactNode } from 'react';
import {
  ComboboxCreateItem,
  useComboboxQuery
} from 'v5/design-system/Combobox';

/** `ComboboxCreateItem` for a search with text in it; selects the trimmed text. */
export function CreateFromQueryItem({
  onSelect,
  children
}: {
  onSelect(label: string): void;
  children: ReactNode;
}) {
  const query = useComboboxQuery();
  if (query.trim() === '') return null;
  return (
    <ComboboxCreateItem onSelect={label => onSelect(label.trim())}>
      {children}
    </ComboboxCreateItem>
  );
}
